module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_05_american-village-881dbed266b4586324fe5acd54a709aa.jpg";